import { useTranslation } from 'react-i18next';
import { Message } from '@britishcouncil/react-extro-ui';
import { FiAlertCircle } from 'react-icons/fi';

export const ErrorAlert = () => {
  const { t } = useTranslation(['npp']);

  return (
    <Message
      variant="error"
      icon={<FiAlertCircle />}
      size="large"
      header={t('npp:general.error.title')}
    >
      <p>{t('npp:general.error.info')}.</p>
      <p>{t('npp:general.error.cta')}.</p>
    </Message>
  );
};
